// import React, { useEffect, useRef, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { number } from "yup";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const FileLoginModalPopup = ({ onAddUser, AllFileLoginDat }) => {
//   const fileInputRef = useRef(null);

//   const [tableData, setTableData] = useState([]);

//   const [LocalFormData, setLocalFormData] = useState({
//     BranchId: Number,
//     Name: "",
//     Mobile: "",
//     ApplicationNo: "",
//     IsFileLoggedIn: false,
//     ExpectedDate: "",
//     Latitude: "",
//     Longitude: "",
//   });

//   // console.log("data",radioValue)

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, ExpectedDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         const { latitude, longitude } = position.coords;
//         setLocalFormData({
//           ...LocalFormData,
//           Latitude: latitude,
//           Longitude: longitude,
//         });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, []);

//   const HandleSubmit = async (e) => {
//     e.preventDefault();
//     const formatDateToUTC = (dateString) => {
//       const date = new Date(dateString);
//       const year = date.getUTCFullYear();
//       const month = String(date.getUTCMonth() + 1).padStart(2, "0");
//       const day = String(date.getUTCDate()).padStart(2, "0");
//       const hours = String(date.getUTCHours()).padStart(2, "0");
//       const minutes = String(date.getUTCMinutes()).padStart(2, "0");
//       const seconds = String(date.getUTCSeconds()).padStart(2, "0");
//       const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");
//       return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
//     };

//     // console.log("object", formatDateToUTC);

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append(
//       "ApplicationNo",
//       LocalFormData.IsFileLoggedIn ? LocalFormData.ApplicationNo : ""
//     );
//     formData.append(
//       "ExpectedDate",
//       LocalFormData.IsFileLoggedIn
//         ? ""
//         : formatDateToUTC(LocalFormData.ExpectedDate)
//     );
//     formData.append("IsFileLoggedIn", LocalFormData.IsFileLoggedIn);
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);

//     // if (LocalFormData.Mobile <=10) {
//     //   ErrorToast("Mobile Number must be atleast 10 digit.")
//     // }
//     try {
//       const response = await axios.post(
//         `${Api_Url}api/v1/FileLogin`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       console.log("response", response);
//       AllFileLoginDat();
//       setLocalFormData({
//         BranchId: "",
//         Name: "",
//         Mobile: "",
//         ApplicationNo: "",
//         ExpectedDate: "",
//         IsFileLoggedIn: false,
//         Latitude: "",
//         Longitude: "",
//       });
//       AllFileLoginDat();
//       resetForm();
//       SuccessToast("File Login Submitted Successfully");
//     } catch (error) {}
//   };

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: Number,
//       Name: "",
//       Mobile: "",
//       ApplicationNo: "",
//       IsFileLoggedIn: false,
//       ExpectedDate: "",
//     });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const [allbranch, setAllBranch] = useState("");

//   const AllBranchName = async () => {
//     try {
//       const response = await axios.get(
//         `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//           headers: {
//             Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//           }
//         }
//       );
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data);
//     } catch (error) {
//       console.log("object", error);
//     }
//   };
//   console.log(allbranch);

//   useEffect(() => {
//     AllBranchName();
//   }, []);

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }
//     // if (value.length <= 10) {
//     //   setLocalFormData({
//     //     ...LocalFormData,
//     //     Mobile: value,
//     //   });
//     //   if (value.length < 10) {
//     //     ErrorToast("Mobile Number must be in 10 digit.")
//     //   }else if(validateMobileNumber(value)){
//     //     setLocalFormData({
//     //           ...LocalFormData,
//     //           Mobile: value,
//     //         });
//     //       }else {
//     //         setErrorMessage('Mobile number cannot be more than 10 digits');
//     //   }
//     // }
//   };

//   {/*
//     import React, { useState } from 'react';

// const YourComponent = () => {
//   const [LocalFormData, setLocalFormData] = useState({ Mobile: '' });
//   const [errorMessage, setErrorMessage] = useState('');

//   // Validate for exactly 10 digits
//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{10}$/; // Ensures exactly 10 digits
//     return regex.test(number);
//   };

//   // Handle mobile number change
//   const handleMobileChange = (e) => {
//     const value = e.target.value;

//     if (value.length <= 10) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });

//       if (value.length < 10) {
//         setErrorMessage('Mobile number must be exactly 10 digits');
//       } else if (validateMobileNumber(value)) {
//         setErrorMessage(''); // Clear error when valid
//       }
//     } else {
//       setErrorMessage('Mobile number cannot be more than 10 digits');
//     }
//   };

//   return (
//     <div>
//       <label>Mobile Number:</label>
//       <input
//         type="text"
//         value={LocalFormData.Mobile}
//         onChange={handleMobileChange}
//         maxLength={10}
//       />
//       {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
//     </div>
//   );
// };

// export default YourComponent;

//     */}

//   // console.log("object",LocalFormData)
//   return (
//     <>
//       <div
//         id="add_client"
//         className="modal custom-modal fade"
//         role="dialog"
//         data-bs-backdrop="static"
//         data-bs-keyboard="false"
//       >
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">File Login</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src={AllFormsUpperphoto}
//                   alt="mohit"
//                   className="img-fluid rounded-circle"
//                   style={{ width: "100px", height: "100px" }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             BranchId: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch &&
//                           allbranch.length > 0 &&
//                           allbranch.map((res) => (
//                             <option value={res.id}>{res.name}</option>
//                           ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Customer Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.Name}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             Name: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         value={LocalFormData.Mobile}
//                         onChange={handleMobileChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       File Logged In<span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsFileLoggedIn === true}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsFileLoggedIn: e.target.value === "true",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault1"
//                       >
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value="false"
//                         checked={LocalFormData.IsFileLoggedIn === false}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsFileLoggedIn: e.target.value === "false",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault2"
//                       >
//                         No
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {LocalFormData.IsFileLoggedIn === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Application Number{" "}
//                           <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ApplicationNo}
//                           onChange={(e) =>
//                             setLocalFormData({
//                               ...LocalFormData,
//                               ApplicationNo: e.target.value,
//                             })
//                           }
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Expected Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.VisitDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             BranchId: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch &&
//                           allbranch.length > 0 &&
//                           allbranch.map((res) => (
//                             <option value={res.id}>{res.name}</option>
//                           ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Customer Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.Name}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             Name: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         value={LocalFormData.Mobile}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             Mobile: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       File Logged In<span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsFileLoggedIn === true}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsFileLoggedIn: e.target.value === "true",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault1"
//                       >
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value="false"
//                         checked={LocalFormData.IsFileLoggedIn === false}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsFileLoggedIn: e.target.value === "false",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault2"
//                       >
//                         No
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {LocalFormData.IsFileLoggedIn === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Application Number{" "}
//                           <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ApplicationNo}
//                           onChange={(e) =>
//                             setLocalFormData({
//                               ...LocalFormData,
//                               ApplicationNo: e.target.value,
//                             })
//                           }
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Expected Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.VisitDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// MOdal

import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Modal } from "antd";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Api_Url } from "../../../config/config";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const FileLoginModalPopup = ({ onAddUser, AllFileLoginDat, onClose }) => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [allbranch, setAllBranch] = useState([]);
  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    ApplicationNo: "",
    IsFileLoggedIn: false,
    ExpectedDate: "",
    Latitude: "",
    Longitude: "",
  });

  // Get Current Location on load
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setLocalFormData((prev) => ({
          ...prev,
          Latitude: latitude,
          Longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // Fetch all branches
  const AllBranchName = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
          },
        }
      );
      setAllBranch(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    AllBranchName();
  }, []);

  // Handle Date Change
  const handleDateChange = (date) => {
    setLocalFormData({ ...LocalFormData, ExpectedDate: date });
  };

  // Format Date to UTC
  const formatDateToUTC = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString(); // This formats to UTC ISO string
  };

  // Handle form submission
  const HandleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validation for required fields
    if (!LocalFormData.BranchId || !LocalFormData.Name || !LocalFormData.Mobile || LocalFormData.Mobile.length !== 10) {
      ErrorToast("Please fill in all required fields and ensure the mobile number is 10 digits.");
      setLoading(false);
      return;
    }

    // Prepare form data
    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("ApplicationNo", LocalFormData.IsFileLoggedIn ? LocalFormData.ApplicationNo : "");
    formData.append("ExpectedDate", !LocalFormData.IsFileLoggedIn ? formatDateToUTC(LocalFormData.ExpectedDate) : "");
    formData.append("IsFileLoggedIn", LocalFormData.IsFileLoggedIn);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);

    try {
      const response = await axios.post(`${Api_Url}api/v1/FileLogin`, formData, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user")).accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      SuccessToast("File Login Submitted Successfully");
      AllFileLoginDat();
      resetForm();
      onClose()
    } catch (error) {
      ErrorToast("An error occurred while submitting.");
    }
    setLoading(false);
  };

  // Reset form
  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      ApplicationNo: "",
      ExpectedDate: "",
      IsFileLoggedIn: false,
    });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // Validate mobile number (max 10 digits)
  const validateMobileNumber = (number) => /^[0-9]{0,10}$/.test(number);

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (validateMobileNumber(value)) {
      setLocalFormData({ ...LocalFormData, Mobile: value });
    }
  };

  return (
    <Modal
      title={<h4>Add File Login</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div className="d-flex justify-content-between align-items-center" key="footer">
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary submit-btn" onClick={HandleSubmit} disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
      <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label>Branch <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  value={LocalFormData.BranchId}
                  onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
                >
                  <option value="">Select Branch</option>
                  {allbranch.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label>Customer Name <span className="text-danger">*</span></label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Name}
                  onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label>Mobile <span className="text-danger">*</span></label>
                <input
                  className="form-control"
                  type="text"
                  value={LocalFormData.Mobile}
                  onChange={handleMobileChange}
                />
              </div>
            </div>
            <div className="col-md-12">
              <label>File Logged In <span className="text-danger">*</span></label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="IsFileLoggedIn"
                  value="true"
                  checked={LocalFormData.IsFileLoggedIn === true}
                  onChange={(e) => setLocalFormData({ ...LocalFormData, IsFileLoggedIn: e.target.value === "true" })}
                />
                <label className="form-check-label">Yes</label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="IsFileLoggedIn"
                  value="false"
                  checked={LocalFormData.IsFileLoggedIn === false}
                  onChange={(e) => setLocalFormData({ ...LocalFormData, IsFileLoggedIn: e.target.value === "false" })}
                />
                <label className="form-check-label">No</label>
              </div>
            </div>
            {LocalFormData.IsFileLoggedIn ? (
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label>Application Number <span className="text-danger">*</span></label>
                  <input
                    className="form-control"
                    type="text"
                    value={LocalFormData.ApplicationNo}
                    onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })}
                  />
                </div>
              </div>
            ) : (
              <div className="col-md-6">
                <div className="input-block mb-3">
                  <label>Expected Date <span className="text-danger">*</span></label>
                  <DatePicker
                    selected={LocalFormData.ExpectedDate}
                    onChange={handleDateChange}
                    className="form-control"
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );
};

